import React, { Component } from 'react';
import { Link } from 'react-router';
import Moment from 'moment';
import BlogLast from './BlogLast';

export default class BlogDetails extends Component {

    constructor(props) {
        super(props);
        this.state = {
            post: {
                id: '',
                titulo: '',
                corpo: '',
                categoria: {
                    id: '',
                    nome: ''
                },
                imagemLink: ''
            }
        };
    }

    componentWillMount() {
        const requestInfo = {
            method: 'GET',
            headers: new Headers({
                'Content-type': 'application/json',
                'Access-Control-Allow-Origin': '*'
            })
        };

        fetch('http://api.fcsistema.com.br/api-website-fc/post/byId/' + this.props.params.id, requestInfo)
            .then(response => response.json())
            .then(data => {
                this.setState({ post: data });
            })
            .catch(error => {
                this.setState({ msg: error.message });
            });
    }

    render() {
        return (
            <div>
                <section className="page-title ptb-50">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                                <h2>{this.state.post.titulo}</h2>
                                <ol className="breadcrumb">
                                    <li><Link to="/">Home</Link></li>
                                    <li><Link to="/blog">Blog</Link></li>
                                    <li className="active">Ler post</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="blog-section padding-top-50">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="posts-content single-post">

                                    <article className="post-wrapper">

                                        <header className="entry-header-wrapper clearfix">

                                            <div className="author-thumb waves-effect waves-light">
                                                
                                            </div>

                                            <div className="entry-header">
                                                <h2 className="entry-title">{this.state.post.titulo}</h2>

                                                <div className="entry-meta">
                                                    <ul className="list-inline">
                                                        <li>
                                                            <i className="fa fa-user"></i>Admin
                                                        </li>

                                                        <li>
                                                            <i className="fa fa-clock-o"></i>{Moment(this.state.post.dataPublicacao).format('MMM d, YYYY')}
                                                        </li>

                                                        {/* <li>
                                                            <i className="fa fa-heart-o"></i><a href="#"><span>1</span></a>
                                                        </li>

                                                        <li>
                                                            <i className="fa fa-comment-o"></i><a href="#">3</a>
                                                        </li> */}
                                                    </ul>
                                                </div>
                                            </div>

                                        </header>

                                        <div className="thumb-wrapper">
                                            <img src={this.state.post.imagemLink} className="img-responsive" alt="" />
                                        </div>


                                        <div className="entry-content" dangerouslySetInnerHTML={{__html: this.state.post.corpo}}>
                                        </div>


                                        <footer className="entry-footer">
                                            <div className="post-tags">
                                                <span className="tags-links">
                                                    <i className="fa fa-tags"></i>
                                                    <a href={'/blog/' + this.state.post.categoria.id}>{this.state.post.categoria.nome}</a>
                                                </span>
                                            </div>

                                            {/* <ul className="list-inline right share-post">
                                                <li><a href="#"><i className="fa fa-facebook"></i> <span>Curtir</span></a>
                                                </li>
                                            </ul> */}
                                        </footer>

                                    </article>

                                    {/* <div className="comments-wrapper">
                                        <div className="comments-tab">



                                            <div className="panel-body">
                                                <h2>Deixe seu comentário</h2>
                                                <div className="tab-content">
                                                    <div role="tabpanel" className="tab-pane fade in active" id="default-comment">
                                                        <div className="comment-respond">

                                                            <form action="#" method="post" id="commentform" noValidate="" role="form">
                                                                <div className="form-group">
                                                                    <input className="form-control" id="author" placeholder="Preencha seu nome" name="author" type="text" value="" aria-required="true" />
                                                                </div>

                                                                <div className="form-group comment-form-comment">
                                                                    <textarea className="form-control" id="comment" name="comment" placeholder="Comentário" rows="8" aria-required="true"></textarea>
                                                                </div>

                                                                <div className="form-submit">
                                                                    <button className="btn btn-lg pink waves-effect waves-light" name="submit" type="submit" id="submit" value="" >Enviar</button>
                                                                </div>
                                                            </form>

                                                        </div>

                                                    </div>
                                                </div>
                                            </div>

                                        </div>

                                    </div> */}




                                </div>
                            </div>

                        </div>
                    </div>
                </section>

                <BlogLast />
            </div>
        );
    }

}


// WEBPACK FOOTER //
// ./src/components/BlogDetails.js